import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { renderToString } from 'react-dom/server';

import { AuthorOpinionDisclaimer } from '../../components/AuthorOpinionDisclaimer';

interface IUseContentAuthorOpinionDisclaimerParams {
  canParse: boolean;
  canRender: boolean;
  postContent: string;
  setPostContent: Dispatch<SetStateAction<string>>;
  done(): void;
  options?: Record<string, boolean>;
}

/**
 * Рендерит дисклеймер автора
 */
export const useContentAuthorOpinionDisclaimer = ({
  canParse,
  postContent,
  setPostContent,
  done,
  options,
}: IUseContentAuthorOpinionDisclaimerParams) => {
  const { pathname } = useLocation();
  const [prevPathname, setPrevPathname] = useState(pathname);
  const [isParsed, setIsParsed] = useState(false);

  /** Сбрасывает стэйт при клиентском переходе с поста на пост */
  useEffect(() => {
    if (pathname !== prevPathname) {
      setPrevPathname(pathname);
      setIsParsed(false);
    }
  }, [pathname, prevPathname]);

  /** Парсит параметры */
  useEffect(() => {
    if (!canParse || isParsed) {
      return;
    }

    if (options?.isEnabled) {
      const disclaimer = renderToString(<AuthorOpinionDisclaimer />);

      if (!postContent.includes(disclaimer)) {
        setPostContent(`${postContent}${disclaimer}`);
      }
    }

    setIsParsed(true);
    done();
  }, [canParse, done, isParsed, options?.isEnabled, postContent, setPostContent]);
};
